export const CHANNELS_ADD_NEW = "channels/add_new_channel";
export const INSTANCES_ADD_NEW = "instances_page/add_new_button";
export const MEETING_TYPE_ADD_NEW_CHANNEL = "meeting_type_page/add_new_channel";
export const QUICK_LAUNCH = "quick_launch";

export { default as useCreationMeta } from "./useCreationMeta";
